'use client'

import tucanLogoDark from 'components/logo/tucan.logo.dark.svg'
import React, { CSSProperties, ReactNode, useMemo } from 'react'
import styled from 'styled-components'
import { getPublicEnv } from '@tucan/utils'
import { PageCenter } from './page.center'

const LogoLink = styled.a`
  position: absolute;
  top: 0;
  left: 0;
  padding: 18px;

  img {
    height: 38px;
  }
`

const Card = styled.div`
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 12px;
  max-width: 90%;
  width: 650px;
  padding: 72px;
  z-index: 10;

  @media (max-width: 800px) {
    padding: 40px;
  }

  @media (max-width: 600px) {
    padding: 20px;
    max-width: 95%;
  }

  @media (max-width: 450px) {
    max-width: 100%;
    border-radius: 0;
  }

  h1 {
    font-size: 27px;
    line-height: 38px;
    color: #181818;
    font-weight: bold;
    text-align: center;
    letter-spacing: -0.01em;
    margin-bottom: 40px;

    small {
      display: block;
      font-size: 14px;
      font-weight: normal;
      line-height: 22px;
      margin-top: 16px;
      letter-spacing: -0.02em;
      color: #747474;
    }
  }
`

const Logo = styled.img`
  margin-left: auto;
  margin-right: auto;
  display: block;
  height: 80px;
  margin-bottom: 40px;
`

interface Props {
  logo?: any
  logoAlt?: string
  children: ReactNode
  cardStyle?: CSSProperties
}

export const PageCenterCard: React.FC<Props> = (props) => {
  const logo = useMemo(() => {
    if (props.logo) {
      return <Logo src={props.logo} alt={props.logoAlt || 'tucan.ai'} />
    }

    if (getPublicEnv('LOGO_URL')) {
      return <Logo src={getPublicEnv('LOGO_URL')} alt={props.logoAlt || 'tucan.ai'} />
    }

    return (
      <Logo
        src={tucanLogoDark.src}
        alt={props.logoAlt || 'tucan.ai'}
      />
    )
  }, [props.logo, props.logoAlt])

  const icon = useMemo(() => {
    if (getPublicEnv('ICON_URL')) {
      return <Logo src={getPublicEnv('ICON_URL')} alt={'tucan.ai'} />
    }

    return (
      <Logo
        src={tucanLogoDark.src}
        alt={'tucan.ai'}
      />
    )
  }, [props.logo, props.logoAlt])

  return (
    <PageCenter footer>
      <LogoLink href={'/'}>
        {icon}
      </LogoLink>

      <Card style={props.cardStyle}>
        {logo}
        {props.children}
      </Card>
    </PageCenter>
  )
}
